import { fanta, PrimaryButton } from '@chegg/fanta'
import styled from 'styled-components'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const CreateAccount = styled(PrimaryButton)`
  width: inherit;
  height: 40px;
  margin-top: 40px;
  padding: 0 ${FantaTheme.spacing.md3};
`
export const CitationLimit = styled.h1`
  ${AspiraStack};
  font-size: ${fanta.font.size.lg};
  height: 24px;
  width: 350px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 29px;
`

export const CreateAccountMessage = styled.p`
  ${AspiraStack};
  font-size: ${fanta.font.size.sm};
  margin-top: 8px;
  height: 18px;
  width: 358px;
  letter-spacing: 0;
  line-height: 18px;
`
